import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useState, useEffect } from 'react';
import { isAxiosError } from 'axios';
import { CircularProgress } from '@mui/material';
import { Wrapper, LogoImage, Title, Description, LoaderContainer } from './styled';
import realush from './assets/images/realush.png';
import { getQueryParam } from '../SignUp/api';
import unsubscribe from '../PromotionalUnsubscribe/api';
import axiosInstance from '@/shared/api/http';
import { API } from '@/shared/constants/api';
const NewUnsubscribed = () => {
    const email = getQueryParam('email');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    useEffect(() => {
        if (!email)
            return;
        setLoading(true);
        (async () => {
            try {
                const { data } = await axiosInstance.post(`${API.encryp}?base64Message=${email}`);
                const response = await unsubscribe(data);
                if (isAxiosError(response)) {
                    setError(true);
                }
            }
            catch (err) {
                setError(true);
            }
            finally {
                setLoading(false);
            }
        })();
    }, [email]);
    if (loading) {
        return (_jsx(LoaderContainer, { children: _jsx(CircularProgress, { color: 'primary', size: 40 }) }));
    }
    if (error) {
        return (_jsxs(Wrapper, { children: [_jsx(Title, { children: "Oops..." }), _jsx(Description, { children: "Something went wrong :(" })] }));
    }
    return (_jsxs(Wrapper, { children: [_jsx(LogoImage, { src: realush }), _jsx(Title, { children: "Sorry to see you go..." }), _jsxs(Description, { children: ["We're sorry to see you go! You have successfully unsubscribed from our promotional emails.", _jsx("br", {}), "\uD83D\uDCE9 Unsubscribed email: ", email, _jsx("br", {}), "You will no longer receive event updates or special offers from Realush."] })] }));
};
export default memo(NewUnsubscribed);
